import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { equipmentApi } from '../api';
import { useEquipmentCostLinkOptions } from '../hooks';
import { EquipmentLinkMode } from '../types';

export default function EquipmentToCostDialog(props: {
  equipmentId: number;
  mode: EquipmentLinkMode;
  setMode: (mode: EquipmentLinkMode) => void;
  callback?: () => void;
}) {
  const { t } = useTranslation();

  const { equipmentId, mode, setMode, callback } = props;
  const { options } = useEquipmentCostLinkOptions(mode);

  const handleClose = () => {
    setMode('');
  };

  const onSubmit = (values: { object_id: number }) => {
    equipmentApi.addCostLink(equipmentId, mode, values.object_id).then(() => {
      toast.success('Fonte di costo aggiunta con successo.');
      handleClose();
      if (callback) callback();
    });
  };

  return (
    <EnhancedDialog
      open={mode.length > 0}
      onClose={handleClose}
      title={'Aggiungi fonte di costo'}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="sm"
      submitButtonProps={{
        type: 'submit',
        form: 'addCostLink'
      }}>
      <EnhancedForm onSubmit={onSubmit} formId="addCostLink" hideControls>
        <div className="w-full my-4">
          {options && (
            <IdentityField
              name="object_id"
              component={AutocompleteAdapter}
              options={options}
              label={t('global.cost-source')}
            />
          )}
        </div>
      </EnhancedForm>
    </EnhancedDialog>
  );
}
